import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { postRecipeFavorite } from '../queries/recipe';
import { useAuthStore } from '../stores';

type UsePostRecipeFavoriteMutationArgs = {
  onSuccess?: () => void;
  onError?: (errorMessage: string) => void;
};

export function usePostRecipeFavoriteMutation({
  onSuccess,
  onError,
}: UsePostRecipeFavoriteMutationArgs = {}) {
  const token = useAuthStore((s) => s.access_token);

  return useMutation({
    mutationFn: (recipeId: string) => postRecipeFavorite(token, recipeId),
    onSuccess() {
      onSuccess?.();
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        onError?.(error.response?.data.message || 'API Error');
      } else if (error instanceof Error) {
        onError?.(error.message);
      } else {
        onError?.('Unexpected Error');
      }
    },
  });
}
